import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, formDataPost, get, patch, post, put } from "helpers/api_helper"
import {
  CREATE_TRIAL_OPERATION,
  UPDATE_TRIAL_OPERATION,
  DELETE_TRIAL_OPERATION,
  TRIAL_OPERATION_INVITE_CANDIDATES,
  DELETE_CATERING,
  GET_ALL_TRIAL_OPERATIONS,
  GET_CATERING_LIST,
  GET_TRAINING_SCHEDULE,
  GET_TRIAL_OPERATION_MATCHED_CANDIDATES_LIST,
  MARK_TRIAL_PERIOD_ATTENDANCE,
  UPDATE_COMMON_SETTINGS,
  TRIAL_OPERATION_INVITE_CANDIDATES_IMPORT,
  GET_TRIAL_OPERATION_DETAILS,
  GET_ALL_TRIAL_OPERATIONS_ATTENDANCE_LIST,
  GET_ALL_TRIAL_OPERATIONS_ENROLLMENT_LIST,
  EDIT_TRIAL_PERIOD_ATTENDANCE,
  GET_ALL_TRIAL_OPERATIONS_REASON_LIST,
  TRIAL_OPERATION_CAPTURE_ABSENT,
  GET_ALL_TRIAL_OPERATIONS_INSPECTION_LIST,
  DELETE_TRIAL_OPERATION_INSPECTION, MARK_TRIAL_OPERATION_INSPECTION_ATTENDANCE
} from "helpers/url_helper"

export const getAllTrialPeriods = createAsyncThunk(
  GET_ALL_TRIAL_OPERATIONS,
  async payload => {
    const response = await post(GET_ALL_TRIAL_OPERATIONS, payload)
    return response
  }
)

export const getTrialOperationDetails = createAsyncThunk(
  GET_TRIAL_OPERATION_DETAILS,
  async uuid => {
    const response = await get(`${GET_TRIAL_OPERATION_DETAILS}${uuid}`)
    return response
  }
)

export const createTrialOperation = createAsyncThunk(
  CREATE_TRIAL_OPERATION,
  async payload => {
    const response = await post(CREATE_TRIAL_OPERATION, payload)
    return response
  }
)

export const updateTrialOperation = createAsyncThunk(
  UPDATE_TRIAL_OPERATION,
  async data => {
    const { uuid, payload } = data
    const response = await put(`${UPDATE_TRIAL_OPERATION}/${uuid}`, payload)
    return response
  }
)

export const deleteTrialOperation = createAsyncThunk(DELETE_TRIAL_OPERATION, async id => {
  const response = await del(`${DELETE_TRIAL_OPERATION}/${id}`)
  return response
})

export const trialOperationInviteCandidate = createAsyncThunk(
  TRIAL_OPERATION_INVITE_CANDIDATES,
  async payload => {
    const response = await post(TRIAL_OPERATION_INVITE_CANDIDATES, payload)
    return response
  }
)

export const trialOperationInviteCandidateViaFile = createAsyncThunk(
  TRIAL_OPERATION_INVITE_CANDIDATES_IMPORT,
  async payload => {
    const response = await formDataPost( TRIAL_OPERATION_INVITE_CANDIDATES_IMPORT, payload)
    return response
  }
)

export const getTrialPeriodMatchedCandidatesList = createAsyncThunk(
  GET_TRIAL_OPERATION_MATCHED_CANDIDATES_LIST,
  async payload => {
    const response = await post(
      GET_TRIAL_OPERATION_MATCHED_CANDIDATES_LIST,
      payload
    )
    return response
  }
)

export const updateSettings = createAsyncThunk(
  UPDATE_COMMON_SETTINGS,
  async payload => {
    const response = await post(UPDATE_COMMON_SETTINGS, payload)
    return response
  }
)

export const getCateringList = createAsyncThunk(
  GET_CATERING_LIST,
  async payload => {
    const response = await post(GET_CATERING_LIST, payload)
    return response
  }
)

export const deleteCatering = createAsyncThunk(
  DELETE_CATERING,
  async payload => {
    const response = await del(`${DELETE_CATERING}/${payload}`)
    return response
  }
)

export const getTrialPeriodSchedule = createAsyncThunk(
  GET_TRAINING_SCHEDULE,
  async payload => {
    const response = await post(GET_TRAINING_SCHEDULE, payload)
    return response
  }
)

export const markTrialPeriodAttendance = createAsyncThunk(
  MARK_TRIAL_PERIOD_ATTENDANCE,
  async payload => {
    const response = await post(MARK_TRIAL_PERIOD_ATTENDANCE, payload)
    return response
  }
)

export const trialOperationCaptureAbsent = createAsyncThunk(
  TRIAL_OPERATION_CAPTURE_ABSENT,
  async payload => {
    const response = await post(TRIAL_OPERATION_CAPTURE_ABSENT, payload)
    return response
  }
)

export const editTrialPeriodAttendance = createAsyncThunk(
  EDIT_TRIAL_PERIOD_ATTENDANCE,
  async payload => {
    const response = await post(EDIT_TRIAL_PERIOD_ATTENDANCE, payload)
    return response
  }
)

export const getAllTrialOperationsAttendanceList = createAsyncThunk(
  GET_ALL_TRIAL_OPERATIONS_ATTENDANCE_LIST,
  async payload => {
    const response = await post(GET_ALL_TRIAL_OPERATIONS_ATTENDANCE_LIST, payload)
    return response
  }
)

export const getAllTrialOperationsEnrollmentList = createAsyncThunk(
  GET_ALL_TRIAL_OPERATIONS_ENROLLMENT_LIST,
  async payload => {
    const response = await post(GET_ALL_TRIAL_OPERATIONS_ENROLLMENT_LIST, payload)
    return response
  }
)

export const getAllTrialOperationsReasonList = createAsyncThunk(
  GET_ALL_TRIAL_OPERATIONS_REASON_LIST,
  async () => {
    const response = await get(GET_ALL_TRIAL_OPERATIONS_REASON_LIST)
    return response
  }
)

export const markTrialOperationInspectionAttendance = createAsyncThunk(
  MARK_TRIAL_OPERATION_INSPECTION_ATTENDANCE,
  async payload => {
    const response = await post(MARK_TRIAL_OPERATION_INSPECTION_ATTENDANCE, payload)
    return response
  }
)

export const getAllTrialOperationsInspectionList = createAsyncThunk(
  GET_ALL_TRIAL_OPERATIONS_INSPECTION_LIST,
  async payload => {
    const response = await post(GET_ALL_TRIAL_OPERATIONS_INSPECTION_LIST, payload)
    return response
  }
)

export const deleteTrialOperationInspection = createAsyncThunk(DELETE_TRIAL_OPERATION_INSPECTION, async id => {
  const response = await del(`${DELETE_TRIAL_OPERATION_INSPECTION}${id}`)
  return response
})